import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '../../shared/components/OkCancelModal';
import messages from './priceGridMessages';

class PriceGridNameModal extends Component {
  state = {
    name: '',
    saving: false,
  };
  constructor(props) {
    super(props);
    this.state.name = props.grid ? props.grid.name : '';
  }
  componentDidUpdate(oldProps) {
    const { grid } = this.props;
    if (JSON.stringify(oldProps.grid) !== JSON.stringify(grid)) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        name: grid.name,
      });
    }
  }
  handleSubmit = () => {
    const { onSave, grid } = this.props;
    const { name } = this.state;
    if (!name) return Promise.reject();
    return new Promise(resolve => {
      this.setState({ saving: true }, () => {
        resolve(onSave({ ...grid, name }));
      });
    }).finally(() => {
      this.setState({ saving: false });
    });
  };
  handleCancel = () => {
    const { onClose } = this.props;
    onClose();
  };

  handleKeyDown = e => {
    // Escape
    if (e.keyCode === 27) {
      this.handleCancel();
      e.preventDefault();
      e.stopPropagation();
      if (e.nativeEvent) e.nativeEvent.stopImmediatePropagation();
    }
    // Enter
    else if (e.keyCode === 13) {
      this.handleSubmit();
      e.preventDefault();
      e.stopPropagation();
      if (e.nativeEvent) e.nativeEvent.stopImmediatePropagation();
    }
  };

  render() {
    const { title, intl } = this.props;
    const { name, saving } = this.state;
    return (
      <OkCancelModal
        show
        title={title}
        onClose={this.handleCancel}
        onSave={this.handleSubmit}
        disabled={!name || saving}
      >
        <div className="form-horizontal">
          <div className="form-group">
            <label htmlFor="nameInput" className="col-sm-2 control-label">
              <FormattedMessage {...messages.Name} />
            </label>
            <div className="col-sm-10">
              <input
                type="text"
                className="form-control"
                id="nameInput"
                value={name}
                onChange={e => this.setState({ name: e.target.value })}
                onKeyDown={this.handleKeyDown}
                placeholder={intl.formatMessage(messages.Name)}
                autoFocus
                autoComplete="off"
                data-1p-ignore
              />
            </div>
          </div>
        </div>
      </OkCancelModal>
    );
  }
}

PriceGridNameModal.propTypes = {
  grid: PropTypes.shape({ id: PropTypes.string, name: PropTypes.string }).isRequired,
  title: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  intl: intlShape.isRequired,
};
PriceGridNameModal.defaultProps = {
  title: '',
  onSave: () => {},
};

export default injectIntl(PriceGridNameModal);
